/* Maison Byōbu V2 · filtres en pastilles, tri et affichage progressif des grilles de coloris (08/10).
   Tout se fait dans le navigateur, à partir des attributs data- des cartes (snippet mb-v2-carte) : aucune application.
   Règle : OU à l'intérieur d'une famille (chambre ou salon), ET entre familles (chambre et vert).
   L'état des filtres est recopié dans l'adresse (?couleur=vert&style=naturel) pour qu'un lien partagé retrouve la sélection.
   Sans JavaScript, toutes les cartes restent visibles. */
(() => {
  const LIBELLES = {
    piece: { salon: 'Salon', chambre: 'Chambre', 'chambre-enfant': 'Chambre d’enfant', cuisine: 'Cuisine', 'salle-de-bain': 'Salle de bain', 'salle-a-manger': 'Salle à manger', bureau: 'Bureau', entree: 'Entrée et couloir' },
    couleur: { blanc: 'Blanc', beige: 'Beige', sepia: 'Sépia', marron: 'Marron', terracotta: 'Terracotta', orange: 'Orange', jaune: 'Jaune', kaki: 'Kaki', vert: 'Vert', bleu: 'Bleu', violet: 'Violet', rose: 'Rose', rouge: 'Rouge', gris: 'Gris', noir: 'Noir', 'noir-et-blanc': 'Noir et blanc', multicolore: 'Multicolore', or: 'Or' },
    style: { contemporain: 'Contemporain', naturel: 'Naturel', scandinave: 'Scandinave', classique: 'Classique', mediterraneen: 'Méditerranéen', eclectique: 'Éclectique' },
    emotion: { serenite: 'Sérénité', harmonie: 'Harmonie', evasion: 'Évasion', chaleur: 'Chaleur', audace: 'Audace', emerveillement: 'Émerveillement' },
    univers: { 'univers-botanique': 'Botanique', 'univers-paysages': 'Paysages & rivages', 'univers-graphique': 'Graphique & abstrait', 'univers-matieres': 'Matières', 'univers-classiques': 'Classiques revisités', 'univers-enfants': 'Enfants', 'univers-heritage-japonais': 'Héritage japonais' },
  };
  /* Pastilles de couleur : teinte indicative (jamais du texte), les autres familles sont des pilules de texte */
  const TEINTES = { blanc: '#FAFAF8', beige: '#D9CBB2', sepia: '#9C7B57', marron: '#6B4A33', terracotta: '#B9623F', orange: '#D98A3A', jaune: '#E3C25B', kaki: '#8A8A5C', vert: '#5E8063', bleu: '#4F6E8F', violet: '#7D6A93', rose: '#D9A5A0', rouge: '#A8382D', gris: '#9A978F', noir: '#272018', 'noir-et-blanc': 'linear-gradient(135deg,#272018 50%,#FAFAF8 50%)', multicolore: 'conic-gradient(#B9623F,#E3C25B,#5E8063,#4F6E8F,#D9A5A0,#B9623F)', or: '#C7A35E' };

  document.querySelectorAll('[data-mb-v2-grille]').forEach((grille) => {
    const zone = grille.querySelector('[data-mb-v2-cartes]');
    const cartes = [...zone.querySelectorAll('[data-mb-v2-carte]')];
    const paquet = parseInt(grille.dataset.paquet, 10) || 48;
    const compteur = grille.querySelector('[data-mb-v2-compteur]');
    const tri = grille.querySelector('[data-mb-v2-tri]');
    const suite = grille.querySelector('[data-mb-v2-suite]');
    const vus = grille.querySelector('[data-mb-v2-vus]');
    const plus = grille.querySelector('[data-mb-v2-plus]');
    const vide = grille.querySelector('[data-mb-v2-vide]');
    const effacers = grille.querySelectorAll('[data-mb-v2-effacer]');
    const boiteFiltres = grille.querySelector('[data-mb-v2-filtres]');
    const familles = [...grille.querySelectorAll('[data-famille]')].map((f) => f.dataset.famille);
    const valeurs = (c, f) => (c.dataset[f] || '').split(' ').filter(Boolean);
    const choix = Object.fromEntries(familles.map((f) => [f, new Set()]));
    let montrees = paquet;

    /* Lecture de l'adresse : ?couleur=vert,bleu */
    const params = new URLSearchParams(location.search);
    familles.forEach((f) => (params.get(f) || '').split(',').filter(Boolean).forEach((v) => choix[f].add(v)));
    if (params.get('tri') && tri) tri.value = params.get('tri');

    /* Construction des pastilles à partir des valeurs réellement présentes, dans l'ordre des libellés */
    familles.forEach((f) => {
      const bloc = grille.querySelector(`[data-famille="${f}"]`);
      const conteneur = bloc.querySelector('[data-pastilles]');
      const presentes = new Set(cartes.flatMap((c) => valeurs(c, f)));
      const ordre = Object.keys(LIBELLES[f] || {}).filter((v) => presentes.has(v));
      presentes.forEach((v) => { if (!ordre.includes(v)) ordre.push(v); });
      if (ordre.length < 2) { bloc.hidden = true; choix[f].clear(); return; }
      ordre.forEach((v) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'mb-v2g__pastille' + (f === 'couleur' ? ' mb-v2g__pastille--teinte' : '');
        b.dataset.valeur = v;
        b.setAttribute('aria-pressed', String(choix[f].has(v)));
        if (f === 'couleur') {
          const t = document.createElement('i');
          t.setAttribute('aria-hidden', 'true');
          t.style.background = TEINTES[v] || 'var(--mb-filet)';
          b.append(t);
        }
        const nom = document.createElement('span');
        nom.textContent = (LIBELLES[f] && LIBELLES[f][v]) || v;
        const nb = document.createElement('small');
        nb.className = 'mb-v2g__nb';
        b.append(nom, nb);
        b.addEventListener('click', () => {
          choix[f].has(v) ? choix[f].delete(v) : choix[f].add(v);
          b.setAttribute('aria-pressed', String(choix[f].has(v)));
          montrees = paquet;
          appliquer(true);
          if (window.mbMesure) window.mbMesure('collection_filtre', { famille: f, valeur: v, actif: choix[f].has(v) });
        });
        conteneur.append(b);
      });
    });
    if (boiteFiltres && familles.some((f) => !grille.querySelector(`[data-famille="${f}"]`).hidden)) boiteFiltres.hidden = false;

    const correspond = (c, sauf) => familles.every((f) => f === sauf || !choix[f].size || valeurs(c, f).some((v) => choix[f].has(v)));

    const trier = () => {
      const mode = tri ? tri.value : 'maison';
      const cle = {
        maison: (c) => +c.dataset.rang,
        nouveautes: (c) => -c.dataset.date,
        'prix-croissant': (c) => +c.dataset.prix * 10000 + +c.dataset.rang,
        'prix-decroissant': (c) => -c.dataset.prix * 10000 + +c.dataset.rang,
      }[mode] || ((c) => +c.dataset.rang);
      cartes.slice().sort((a, b) => cle(a) - cle(b)).forEach((c) => zone.append(c));
    };

    const ecrireAdresse = () => {
      const p = new URLSearchParams(location.search);
      familles.forEach((f) => (choix[f].size ? p.set(f, [...choix[f]].join(',')) : p.delete(f)));
      if (tri && tri.value !== 'maison') p.set('tri', tri.value); else p.delete('tri');
      p.delete('page');
      const q = p.toString();
      history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash);
    };

    const appliquer = (ecrire) => {
      const ordre = [...zone.querySelectorAll('[data-mb-v2-carte]')];
      const retenues = ordre.filter((c) => correspond(c));
      let n = 0;
      ordre.forEach((c) => {
        const ok = retenues.includes(c);
        const visible = ok && n < montrees;
        if (ok) n++;
        c.hidden = !visible;
        /* Décalage d'apparition court, par rangée, pour ne jamais attendre une carte lointaine */
        if (visible) c.style.setProperty('--mb-i', String((n - 1) % 3));
      });
      const total = retenues.length;
      if (compteur) compteur.textContent = `${total} papier${total > 1 ? 's' : ''} peint${total > 1 ? 's' : ''}`;
      if (vide) vide.hidden = total > 0;
      if (suite) {
        suite.hidden = total <= montrees;
        if (vus) vus.textContent = `${Math.min(montrees, total)} sur ${total}`;
      }
      const actifs = familles.some((f) => choix[f].size);
      effacers.forEach((b) => { if (!b.closest('[data-mb-v2-vide]')) b.hidden = !actifs; });
      /* Nombre de résultats que donnerait chaque pastille, compte tenu des autres familles */
      familles.forEach((f) => {
        grille.querySelectorAll(`[data-famille="${f}"] .mb-v2g__pastille`).forEach((b) => {
          const v = b.dataset.valeur;
          const k = cartes.filter((c) => correspond(c, f) && valeurs(c, f).includes(v)).length;
          b.querySelector('.mb-v2g__nb').textContent = k;
          b.disabled = k === 0 && !choix[f].has(v);
        });
      });
      if (ecrire) ecrireAdresse();
    };

    if (tri) tri.addEventListener('change', () => { trier(); montrees = paquet; appliquer(true); });
    if (plus) plus.addEventListener('click', () => {
      const premiere = [...zone.querySelectorAll('[data-mb-v2-carte]')].find((c) => c.hidden && correspond(c));
      montrees += paquet;
      appliquer(false);
      if (premiere) { const lien = premiere; requestAnimationFrame(() => lien.focus({ preventScroll: true })); }
    });
    effacers.forEach((b) => b.addEventListener('click', () => {
      familles.forEach((f) => choix[f].clear());
      grille.querySelectorAll('.mb-v2g__pastille').forEach((p) => p.setAttribute('aria-pressed', 'false'));
      montrees = paquet;
      appliquer(true);
    }));

    trier();
    appliquer(false);
    grille.classList.add('mb-v2g--pret');
  });
})();
